export default "__VITE_ASSET__Cwucvklc__"